/*
 * Size Guide — transpose the chart at render.
 *
 * The size_chart metaobjects author their tables WIDE (sizes across the top as
 * column headers, measurements — Chest/Waist/Hip/Sleeve — down the side). That's
 * easy to read/enter in the admin but renders very wide on the storefront (heritage
 * charts hit 14 size columns). We flip it to TALL here: sizes become the left-hand
 * row headers and the measurements run across the top. ~4-5 columns instead of 14,
 * so it fits the foldout drawer without going dense or scrolling horizontally.
 *
 * Idempotent (guarded by data-transposed). ARIA scopes are rebuilt so screen readers
 * still get a correctly-associated header/data grid after the flip.
 */
(function () {
  function cellText(node) {
    return node ? node.innerHTML : '';
  }

  function transpose(table) {
    if (table.dataset.transposed === 'true') return;

    var thead = table.querySelector('thead');
    var tbody = table.querySelector('tbody');
    var headRow = thead && thead.querySelector('tr');
    if (!thead || !tbody || !headRow) return;

    var headCells = Array.prototype.slice.call(headRow.children);
    // headCells[0] is the empty corner; the rest are the size labels.
    var sizes = headCells.slice(1).map(cellText);

    var measures = Array.prototype.slice.call(tbody.querySelectorAll('tr')).map(function (tr) {
      var cells = Array.prototype.slice.call(tr.children);
      return { label: cellText(cells[0]), values: cells.slice(1).map(cellText) };
    });

    // New header row: empty corner, then each measurement label across the top.
    var newThead = document.createElement('thead');
    var htr = document.createElement('tr');
    var corner = document.createElement('th');
    corner.setAttribute('scope', 'col');
    htr.appendChild(corner);
    measures.forEach(function (m) {
      var th = document.createElement('th');
      th.setAttribute('scope', 'col');
      th.innerHTML = m.label;
      htr.appendChild(th);
    });
    newThead.appendChild(htr);

    // New body: one row per size, with that size as the row header.
    var newTbody = document.createElement('tbody');
    sizes.forEach(function (sizeLabel, i) {
      var tr = document.createElement('tr');
      var th = document.createElement('th');
      th.setAttribute('scope', 'row');
      th.innerHTML = sizeLabel;
      tr.appendChild(th);
      measures.forEach(function (m) {
        var td = document.createElement('td');
        td.innerHTML = m.values[i] !== undefined ? m.values[i] : '';
        tr.appendChild(td);
      });
      newTbody.appendChild(tr);
    });

    table.replaceChild(newThead, thead);
    table.replaceChild(newTbody, tbody);
    table.dataset.transposed = 'true';
  }

  function run() {
    document.querySelectorAll('.size-guide .size-chart__table').forEach(transpose);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
